<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="新增任务"
    >
        <div class="container">
            <el-form
                ref="addForm"
                :rules="rules"
                :model="addForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="所属项目"
                            size="small"
                            prop="project_id"
                        >
                            <el-select
                                v-model="addForm.project_id"
                                filterable
                                placeholder="请选择所属项目"
                                @change="projectTeam"
                                :disabled="projectDisabled"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="指派人"
                            size="small"
                            prop="appointor"
                        >
                            <el-select
                                v-model="addForm.appointor"
                                multiple
                                filterable
                                placeholder="请选择指派人"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划时间" size="small" prop="time">
                            <el-date-picker
                                v-model="addForm.time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                @change="changeHandle"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="优先级"
                            size="small"
                            prop="priority"
                        >
                            <el-select
                                v-model="addForm.priority"
                                placeholder="请选择优先级"
                            >
                                <el-option
                                    :label="i"
                                    :value="i"
                                    v-for="i in 5"
                                    :key="i"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="任务标题"
                            size="small"
                            prop="title"
                        >
                            <el-input
                                clearable
                                placeholder="请输入任务标题"
                                maxlength="100"
                                show-word-limit
                                size="small"
                                v-model="addForm.title"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="任务内容"
                            size="small"
                            prop="content"
                        >
                            <vue-tinymce
                                v-if="addVisible"
                                v-model="addForm.content"
                                :setting="setting"
                                :setup="setup"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" size="small" prop="remark">
                            <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入备注"
                                :autosize="{ minRows: 5 }"
                                size="small"
                                v-model="addForm.remark"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="附件内容"
                            size="small"
                            prop="files"
                        >
                            <fileUpload
                                ref="fileUpload"
                                @fileUploaded="fileChange"
                                :limit="1"
                                type="文件"
                            ></fileUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="addVisible = false">关闭</el-button>
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import { mapState } from "vuex";
import fileUpload from "@/comon/components/fileUpload.vue";
export default {
    data() {
        return {
            addForm: {
                project_id: "",
                title: "",
                content: "",
                priority: 1,
                start_time: "",
                end_time: "",
                remark: "",
                appointor: [],
                files: "",
                time: [],
            },
            rules: {
                project_id: [
                    {
                        required: true,
                        message: "请选择所属项目",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入任务标题",
                        trigger: "blur",
                    },
                ],
                priority: [
                    {
                        required: true,
                        message: "请选择优先级",
                        trigger: "change",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "请选择计划起始时间",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: false,
                        message: "请输入任务内容",
                        trigger: "blur",
                    },
                ],
                Appointor: [
                    {
                        required: true,
                        message: "请选择指派人",
                        trigger: "blur",
                    },
                ],
                /* remark: [
                    {
                        required: true,
                        message: "请输入备注",
                        trigger: "blur",
                    },
                ],
                files: [
                    {
                        required: true,
                        message: "请上传附件",
                        trigger: "blur",
                    },
                ], */
            },
            staffList: [],
            appointor: [],
            projectList: [],
            projectDisabled: false
        };
    },
    props: {
        addVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        addVisible: {
            handler(newValue) {
                if (newValue) {
                    // this.getStaffSelect();
                    this.projectSelect();
                    if(this.tableItem){
                        this.addForm.project_id = this.tableItem.project_id;
                        this.addForm.title = this.tableItem.name;
                        this.addForm.content = this.tableItem.content;
                        if(this.tableItem){
                            this.addForm.time = [this.tableItem.response_time.slice(0,10), this.tableItem.estimate_time]
                        }
                    
                        this.projectTeam(this.addForm.project_id);
                        this.projectDisabled = true;
                    }
                }
            },
        },
    },
    created() {
        if(!this.tableItem){
            this.addForm.time = [this.moment().format('YYYY-MM-DD'), this.moment().format('YYYY-MM-DD')]
        }
        
    },
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.addForm.appointor = this.addForm.appointor.toString();
                    this.addForm.start_time = this.addForm.time[0];
                    this.addForm.end_time = this.addForm.time[1];
                    if(this.tableItem){
                        this.addForm.work_orders_id = this.tableItem.id;
                    }
                    oaApi.job({ ...this.addForm }, "post").then((res) => {
                        if (res) {
                            // 不是从工单管理的转任务进来的
                            if(!this.tableItem){
                                this.$parent.job();
                            }else{
                                this.$parent.workOrdersList();
                            }
                            this.closeDialog();
                            this.$message.success("新增成功!");
                        }
                    });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:addVisible", false);
            this.$refs["addForm"].resetFields();
            this.$refs["addForm"].clearValidate();
            // 清除上一次简历文件
            this.$refs.fileUpload.clearFiles();
        },
        fileChange(data) {
            this.addForm.files = data;
            this.$refs["addForm"].clearValidate("files");
        },
        getStaffSelect() {
            oaApi.select({}, "get").then((res) => {
                if (res) {
                    this.staffList = res.data;
                }
            });
        },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            let status = this.tableItem ? "" : 5;
            oaApi.projectSelect({ status }, "get").then((res) => {
                if (res.code == 200) {
                    this.projectList = res.data;
                }
            });
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", (e) => {
                this.$refs["addForm"].clearValidate("content");
            });
            editor.on("KeyDown", (e) => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src,
                                },
                                "post"
                            )
                            .then((res) => {
                                if (res.code == 200) {
                                }
                            })
                            .catch((err) => {
                                return false;
                            });
                    }
                }
            });
        },
        changeHandle(val) {
        },
        projectTeam(id) {
            // this.addForm.Appointor = [];
            oaApi.projectTeam({ id }, "get").then((res) => {
                if (res) {
                    this.staffList = res.data;
                }
            });
        },
    },
    components: {
        fileUpload,
    },
    computed: {
        ...mapState({
            setting: (state) => state.index.setting,
            pickerOptions: (state) => state.index.pickerOptions,
        }),
    },
};
</script>

<style lang="scss">
.add {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>